module.exports = __webpack_public_path__ + "static/media/03.466c0247.jpg";